import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import './Dot.scss';

const { block } = bem('dot');

const Dot = ({ color, className, largeSize, ...props }) => (
  <div className={block({ [color]: color, largeSize }, className)} {...props} />
);

Dot.COLORS = {
  GREEN: 'green',
  RED: 'red',
  RED_DARK: 'red-dark',
  LIGHT: 'light',
  DARK: 'dark',
  CLASSPASS_BLUE: 'classpass-blue',
  YELLOW: 'yellow',
};

Dot.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.values(Dot.COLORS)),
  largeSize: PropTypes.bool,
};

export default Dot;
